module.exports = __webpack_public_path__ + "img/logo_bg_color.52608d21.png";